module.exports = __webpack_public_path__ + "img/TotalTransformationTraining.552c5dbf.png";